import * as DKFDS from 'dkfds';
import $ from 'jquery';

function deleteContact() {
    $('#deleteAddressBookContactLoading').show();
    $('form').append("<input type='hidden' name='delete' value='1'>").submit();
}

function showModal($modal) {
    const $selected = $('input:checked[name=selectedContacts]');
    const noContacts = $selected.length;
    const shared = $selected.is('[data-shared="true"]');
    const $text = $('#deleteAddressBookContactText');
    const contactsText = noContacts === 1 ? ' kontakt' : ' kontakter';
    $text.html(`Du er i gang med at slette ${noContacts}${contactsText}.`);
    if (shared) {
        $text.append('<br><br><strong>Bemærk at én eller flere af kontakterne er delt. Hvis du sletter delte kontakter, forsvinder de for alle brugere i virksomheden!</strong>');
    }
    $('#deleteAddressBookContactModalOK').one('click', deleteContact);
}

function onClick() {
    const noContacts = $('input:checked[name=selectedContacts]').length;
    if (noContacts === 0) {
        new DKFDS.Toast(document.getElementById('deleteAddressBookContactError')).show();
    }
    else {
        new DKFDS.Modal(document.getElementById('deleteAddressBookContactModal')).show();
    }
}

$(() => {
    const $modal = $('#deleteAddressBookContactModal');

    $('#btnDeleteAddressBookContactModal').on('click', onClick);
    $modal.get(0).addEventListener('fds.modal.shown', () => showModal($modal))
});
